import React from 'react';
import { IoMenu } from 'react-icons/io5';

// Placeholder images (you'll need to replace these with actual image paths)
import illustration from '../../imgs/aboutUsimg.png'; // Replace with the actual path to the illustration
import personImage from '../../imgs/hero.png'; // Replace with the actual path to the person image
import Footer from './../Footer/Footer';
import BasicNavbar from './../Navbar/BasicNavbar';
import { Link } from 'react-router-dom';

const About = () => {
    return (
        <div className="min-h-screen bg-gray-50">
            {/* Header */}
            <BasicNavbar />

            {/* Main Content */}
            <main className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                {/* Hero Section */}
                <div className="flex flex-col lg:flex-row items-center justify-between gap-8">
                    {/* Text and Stats */}
                    <div className="lg:w-1/2 text-right">
                        <h2 className="text-4xl font-bold text-gray-900 mb-4">
                            Otlob Coach ليه تدرب مع
                        </h2>
                        <ul className="text-gray-600 mb-6">
                            <li>لأنك بتدرب مع مدرب مخصوص لك لوحدك و بالتالي بيشتغل علي امكانياتك و قدراتك</li>
                            <li>.فبتطور اسرع و بكفاءه أعلي</li>
                            <li>لو في اي وقت قررت تغير المدرب حاتلاقي مدربين متخصصين و متميزين و مستعدين يكملوا معاك الطريق لحد ما توصل لاهدافك كلها ، ان شاء الله
                            </li>
                        </ul>
                    </div>

                    {/* Illustration */}
                    <div className="lg:w-1/2 ">
                        <img
                            src={illustration}
                            alt="Illustration of people helping each other"
                            className="w-full h-[680px]  rounded-lg"
                        />
                    </div>
                </div>

                {/* Call to Action Section */}
                <div className="mt-12 flex flex-col lg:flex-row items-center justify-between gap-8">
                    {/* Image */}
                    <div className="lg:w-1/2">
                        <img
                            src={personImage}
                            alt="Person working on laptop"
                            className="w-full h-auto rounded-lg shadow-lg"
                        />
                    </div>

                    {/* Text and Button */}
                    <div className="lg:w-1/2 text-right">
                        <h2 className="text-2xl font-semibold text-green-600 mb-4">-:حاتلاقي في معلومات المدرب المعروضه </h2>
                        <p className="text-gray-600">
                            تقييم دقيق من المتدربين بناء علي الرأي الفردي لكل متدرب في مدربه و عدد الكورسات اللي نفذها كل مدرب
                        </p>
                        <br />
                        <p className='text-gray-600 mb-6'>يالا ابدأ طريق النجاح</p>
                        <Link to="/home" >
                            <button className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 px-6 py-3 rounded-lg font-semibold">
                                ابدأ الآن
                            </button>
                        </Link>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default About;